import { useMemo } from "react";
import { ConnectionInsurerPackageTypeEnum } from "../../../../../types";
const CODE_LABEL_BY_PRODUCT_NAME = {
  "Nu Pensioen (PPI)": "ZLPPI",
  "Nu PensioenRekening (PPI)": "ZLPPI",
  "Exclusief Pensioen (Lifetime)": "ZL"
};
const mapCodeLabelFromProduct = (product) => CODE_LABEL_BY_PRODUCT_NAME[product?.productName] ?? null;
const isCodeLabelField = (field) => field.name?.split(".").pop() === "codeLabel";
const useZwitserlevenSettings = (selectedProduct) => {
  const codeLabel = useMemo(() => mapCodeLabelFromProduct(selectedProduct), [selectedProduct]);
  const applyZwitserlevenSettings = useMemo(
    () => (settingsFields, packageType) => {
      if (packageType !== ConnectionInsurerPackageTypeEnum.Zwitserleven) {
        return settingsFields;
      }
      return settingsFields.map(
        (field) => isCodeLabelField(field) ? { ...field, value: codeLabel ?? field.value ?? field.defaultValue } : field
      );
    },
    [codeLabel]
  );
  return { applyZwitserlevenSettings };
};
export default useZwitserlevenSettings;
